export const RBAC_ROLE_FEEDBACK_STATE_KEY = 'rbacRoleFeedback'

export function buildRbacRoleSavedFeedback({ isEdit, roleId = null }) {
  if (isEdit) {
    return {
      severity: 'success',
      message: 'El rol se actualizó correctamente.'
    }
  }

  return {
    severity: 'success',
    message: 'El rol se creó correctamente.',
    roleId,
    ctaLabel: 'Ir a asignar usuarios',
    ctaKind: 'assign-users'
  }
}
